///////////////////////////////////////////////////

import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, concatMap, mergeMap } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import {
  secondaryMarketProductRefreshFailed,
  secondaryMarketProductRefreshReceived,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';

export function refreshProductByRowIdsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const { searchProductsByCode } = secondaryProductsApiConnector(httpClient);

    return action$.pipe(
      ofType('SECONDARY_MARKET_PRODUCT_REFRESH_REQUESTED'),
      concatMap(({ keys, dlpKeys }) => {
        return searchProductsByCode({ keys, dlpKeys }).pipe(
          mergeMap(({ products }) => of(secondaryMarketProductRefreshReceived(keys, dlpKeys, products))),
          catchError(err =>
            of(
              secondaryMarketProductRefreshFailed(keys, dlpKeys, err),
              showNotificationThunk({
                level: 'danger',
                title: 'Search failure',
                content: ['A technical error prevent search from returning result, please try again'],
                closeAutomatically: false,
              }),
            ),
          ),
        );
      }),
    );
  };
}
